import React, { createContext, useState, useRef } from 'react';
import { v4 as getId } from 'uuid';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { SortByType } from 'sharedTypes/common/sortByType';

type PendoPayloadType = {
  userAction: string;
  correlationId?: string,
  filters?: { [key: string]: any }
  sort?: SortByType
}

const defaultPendoPayload: Partial<PendoPayloadType> = {
  correlationId: null,
  filters: {},
  sort: {}
}

export const FilterTrackingContext = createContext({
  pendoPayload: defaultPendoPayload,
  // eslint-disable-next-line
  handleFilterChange: (newFiltersObject: Partial<PendoPayloadType>) => {
    //noop
  },
  // eslint-disable-next-line
  sendFiltersToPendo: (action: string) => {
    //noop
  }
})

export default function FilterTrackingProvider({ children }: { children: React.ReactNode }) {
  const [pendoPayload, setPendoPayload] = useState <Partial<PendoPayloadType>>(defaultPendoPayload);
  const lastIdSent = useRef(undefined);
  const { FEATURE_FILTER_CONFIGURATION_PENDO } = useFlags();

  const sendFiltersToPendo = (action: string) => {
    if (FEATURE_FILTER_CONFIGURATION_PENDO) {
      if (pendoPayload.correlationId && lastIdSent.current !== pendoPayload.correlationId && window.pendo) {
        lastIdSent.current = pendoPayload.correlationId;
        const pickUp = pendoPayload.filters.PickupLocation;
        const dropOff = pendoPayload.filters.DropoffLocation;

        const destructuredPayload: { [key: string]: string | number } = {
          userAction: action,
          correlationId: pendoPayload.correlationId,
          ...pendoPayload.filters,
          ...pendoPayload.sort,
          PickupLocation: pickUp?.length ? pickUp[0].Name : null,
          DropoffLocation: dropOff?.length ? dropOff[0].Name : null
        }

        Object.keys(destructuredPayload).forEach((key) => {
          const type = typeof destructuredPayload[key];
          //Deletes empty entries
          if(destructuredPayload[key] === null) {
            delete destructuredPayload[key]
          }
          //Stringifys objects and arrays
          if(type === "object") {
            destructuredPayload[key] = JSON.stringify(destructuredPayload[key])
          }
        })

        window.pendo.track('Load Board > Filters > Filter Configuration', destructuredPayload)
      }
    }
  }

  const handleFilterChange = (newFiltersObject: Partial<PendoPayloadType>) => {
    if (FEATURE_FILTER_CONFIGURATION_PENDO) {
      const correlationId = getId();
      setPendoPayload({
        ...newFiltersObject,
        correlationId
      })
    }
  }

  return (
    <>
      <FilterTrackingContext.Provider value={{ pendoPayload, handleFilterChange, sendFiltersToPendo }}>
        {children}
      </FilterTrackingContext.Provider>
    </>
  )
}
